import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function Testimonials() {
  const {
    t
  } = useLanguage();
  const reviews = t.testimonials.reviews;
  return <section id="testimonios" className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-jet" data-id="element-312">
      <div className="container mx-auto px-4 md:px-6" data-id="element-313">
        <SectionHeading title={t.testimonials.title} subtitle={t.testimonials.subtitle} data-id="element-314" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-16 max-w-7xl mx-auto" data-id="element-315">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -5
        }} className="surface-elevated p-8 rounded-sm flex flex-col h-full transition-shadow duration-500 hover:shadow-[0_30px_80px_rgba(0,0,0,0.6),0_0_60px_rgba(212,168,87,0.18)]" data-id="element-316">
              <div className="flex space-x-1 mb-6" data-id="element-317">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} stroke="url(#riamGold)" fill="url(#riamGoldFill)" className="icon-glow" data-id="element-318" />)}
              </div>
              <p className="font-sans text-riam-gold-light/90 text-base leading-relaxed flex-grow mb-6 italic" data-id="element-319">
                "{review.text}"
              </p>
              <p className="font-script text-riam-gold text-xl font-semibold" data-id="element-320">
                — {review.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}